<template>
  <main class="main">
    <slot />
  </main>
</template>

<script>
import { courseStore } from "@/store/course.js";
export default {
  name: 'LayoutMain',
  data() {
    return {
      store: courseStore(),
    }
  },
  computed: {
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const isPlaying = this.store.getIsPlaying
      const playerH = isPlaying ? 186 : 0
      const hiddenTop = this.store.menuTop + 64 + playerH
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= hiddenTop) {
        this.store.setMenuFixed(true)
      } else {
        this.store.setMenuFixed(false)
      }
    }

  }
}
</script>

<style lang="scss">
.main {
  flex: 1;
  overflow: hidden;
  // margin-top: $header-height;
  .fixed-tabs {
    width: 100%;
    position: fixed;
    top: 0;
    .tabs-content {
      width: $main-max-width;
      margin: 0 auto;
    }
  }
}
</style>